import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Lottie from 'react-lottie-player';

import lottieJson from '../../animations/bell.json';
import { Button } from '@material-ui/core';
import CardOrder from '../../main/order-grid/cardOrder';

function NewOrderDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={props.open}
      maxWidth={'80%'}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle style={{ textAlign: 'center' }} id="alert-dialog-title">Neue Bestellung</DialogTitle>
      <DialogContent>
        <div style={{ justifyContent: 'center', width: '100%', display: 'flex' }}>
          <Lottie
            loop
            animationData={lottieJson}
            play
            style={{ width: 200, height: 200, paddingTop: 30, paddingBottom: 30 }}
          />
        </div>
        {props.orders && props.orders.length ? (
          <div style={{ justifyContent: 'center', width: '100%', display: 'flex', marginBottom: 10, overflowX: 'scroll' }}>
            {props.orders.map(o => (
              <div style={{ marginRight: 10 }}>
                <CardOrder
                  value={o}
                  showTotalPrice={props.showTotalPrice}
                  proceedOrder={props.proceedOrder}
                  declineOrder={props.declineOrder}
                  printOrder={props.printOrder}
                  openDeliveryDialog={props.openDeliveryDialog}
                  printing={props.printingorders[o.id]}
                  isRoutePlanning={props.isRoutePlanning}
                  addOrderToRoute={props.addOrderToRoute}
                  removeOrderFromRoute={props.removeOrderFromRoute}
                  isIncludedInRoute={props.routestops.includes(o.id)}
                  localSettings={props.localSettings}
                />
              </div>),
            )}
          </div>) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onDismiss} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

NewOrderDialog.propTypes = {
  open: PropTypes.bool,
};

NewOrderDialog.defaultProps = {
  onDismiss: () => { },
  open: false,
};

export default NewOrderDialog;
